import { render } from "./StudentGoodMoralDialog.vue?vue&type=template&id=d9637c36&scoped=true"
import script from "./StudentGoodMoralDialog.vue?vue&type=script&lang=js"
export * from "./StudentGoodMoralDialog.vue?vue&type=script&lang=js"

import "./StudentGoodMoralDialog.vue?vue&type=style&index=0&id=d9637c36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9637c36"]])

export default __exports__